@if (isPageInitialized) {
  <div class="maintenance-overview" *transloco="let t; prefix: 'maintenanceOverview'">
    <!-- Header Section -->
    <div class="maintenance-overview__header">
      <h1>{{ t('page.title') }}</h1>
      <div class="maintenance-overview__filters gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter
            [filter]="dateFilter"
            [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals"
            [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>

        <span ngbDropdown class="maintenance-model-filter" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle search-input" id="maintenanceModelFilterDropdown" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ maintenanceModelLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="maintenanceModelFilterDropdown">
            <div class="d-flex flex-column">
              <button class="btn btn-outline" (click)="onMaintenanceModelFilter(null)" ngbDropdownItem>{{ t('page.allModels') }}</button>
              <button class="btn btn-outline" (click)="onMaintenanceModelFilter(maintenanceModelFilter.InHouse)" ngbDropdownItem>{{ t('page.inHouse') }}</button>
              <button class="btn btn-outline" (click)="onMaintenanceModelFilter(maintenanceModelFilter.Contract)" ngbDropdownItem>{{ t('page.contract') }}</button>
            </div>
          </div>
        </span>

        <button class="btn btn-calendar" (click)="onMaintenanceCalendarClick()">{{ t('page.maintenanceCalendar') }}</button>
        <button class="btn btn-create-maintenance" (click)="onCreateMaintenanceClick()">{{ t('page.createMaintenance') }}</button>
      </div>
    </div>

    <!-- Widgets Section -->
    <div class="maintenance-overview__widgets mb-2 mt-2">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-in-maintenance-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)" [maintenanceModel]="maintenanceModel"></app-in-maintenance-widget>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-reactive-maintenance-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)" [maintenanceModel]="maintenanceModel"></app-reactive-maintenance-widget>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-preventive-maintenance-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)" [maintenanceModel]="maintenanceModel"></app-preventive-maintenance-widget>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12">
          <app-overdue-widget [selectedFilter]="getSelectedFilterLabel(dateFilter)" [maintenanceModel]="maintenanceModel"></app-overdue-widget>
        </div>
      </div>
    </div>

    <!-- Tabs Section -->
    <div class="tabs-container w-100">
      <button class="tab-button" [class.active]="isTabActive(maintenanceTab.All)" (click)="onTabChange(maintenanceTab.All)">{{ t('tabs.all') }}</button>
      <button
        class="tab-button"
        [class.active]="isTabActive(maintenanceTab.MaintenanceRequests)"
        (click)="onTabChange(maintenanceTab.MaintenanceRequests)">
        {{ t('tabs.maintenanceRequests') }}
      </button>
      <button
        class="tab-button"
        [class.active]="isTabActive(maintenanceTab.UpcomingMaintenances)"
        (click)="onTabChange(maintenanceTab.UpcomingMaintenances)">
        {{ t('tabs.upcomingMaintenances') }}
      </button>
      <button
        class="tab-button"
        [class.active]="isTabActive(maintenanceTab.OverdueMaintenances)"
        (click)="onTabChange(maintenanceTab.OverdueMaintenances)">
        {{ t('tabs.overdueMaintenances') }}
      </button>
      <button
        class="tab-button"
        [class.active]="isTabActive(maintenanceTab.CompletedMaintenances)"
        (click)="onTabChange(maintenanceTab.CompletedMaintenances)">
        {{ t('tabs.completedMaintenances') }}
      </button>
    </div>

    <!-- Content Section -->
    @if (isTabActive(maintenanceTab.All)) {
      <app-maintenance-overview-all-table
        [maintenanceData]="maintenanceData"
        [isLoading]="isLoading"
        [hasError]="hasError"
        [searchTerm]="searchTerm"
        [accountIds]="accountFilter.accountIds"
        [currentPage]="page"
        [pageSize]="pageSize"
        [totalCount]="totalCount"
        [totalPages]="totalPages"
        (searchTermUpdated)="onSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onAllPageChange($event)"
        (dataRefreshNeeded)="loadData()">
      </app-maintenance-overview-all-table>
    }

    @if (isTabActive(maintenanceTab.MaintenanceRequests)) {
      <app-maintenance-requests-table
        [maintenanceRequests]="maintenanceRequests"
        [isLoading]="isRequestsLoading"
        [hasError]="hasRequestsError"
        [searchTerm]="requestsSearchTerm"
        [currentPage]="requestsPage"
        [pageSize]="pageSize"
        [totalCount]="requestsTotalCount"
        [totalPages]="requestsTotalPages"
        [selectionResetToken]="requestsSelectionResetToken"
        (searchTermUpdated)="onRequestsSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onRequestsPageChange($event)"
        (approveClicked)="onApproveRequest($event)"
        (rejectClicked)="onRejectRequest($event)"
        (bulkApproveClicked)="onBulkApproveRequests($event)"
        (dataRefreshNeeded)="loadData()">
      </app-maintenance-requests-table>
    }

    @if (isTabActive(maintenanceTab.UpcomingMaintenances)) {
      <app-upcoming-maintenances-table
        [upcomingMaintenances]="upcomingMaintenances"
        [isLoading]="isUpcomingLoading"
        [hasError]="hasUpcomingError"
        [searchTerm]="upcomingSearchTerm"
        [currentPage]="upcomingPage"
        [pageSize]="pageSize"
        [totalCount]="upcomingTotalCount"
        [totalPages]="upcomingTotalPages"
        (searchTermUpdated)="onUpcomingSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onUpcomingPageChange($event)"
        (dataRefreshNeeded)="loadData()">
      </app-upcoming-maintenances-table>
    }

    @if (isTabActive(maintenanceTab.OverdueMaintenances)) {
      <app-overdue-maintenances-table
        [overdueMaintenances]="overdueMaintenances"
        [isLoading]="isOverdueLoading"
        [hasError]="hasOverdueError"
        [searchTerm]="overdueSearchTerm"
        [currentPage]="overduePage"
        [pageSize]="pageSize"
        [totalCount]="overdueTotalCount"
        [totalPages]="overdueTotalPages"
        (searchTermUpdated)="onOverdueSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onOverduePageChange($event)"
        (dataRefreshNeeded)="loadData()">
      </app-overdue-maintenances-table>
    }

    @if (isTabActive(maintenanceTab.CompletedMaintenances)) {
      <app-completed-maintenance-overview
        [completedMaintenances]="completedMaintenances"
        [isLoading]="isCompletedLoading"
        [hasError]="hasCompletedError"
        [searchTerm]="completedSearchTerm"
        [currentPage]="completedPage"
        [pageSize]="pageSize"
        [totalCount]="completedTotalCount"
        [totalPages]="completedTotalPages"
        (searchTermUpdated)="onCompletedSearchTermUpdate($event)"
        (exportClicked)="onExportClick()"
        (pageChanged)="onCompletedPageChange($event)">
      </app-completed-maintenance-overview>
    }
  </div>
}